import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@spz/ui/components/popover";
import { type FC, useEffect, useState } from "react";
import { Button } from "./button";
import { TextField, type TextFieldProps } from "./textfield";
import { Typography } from "./typography";

interface TextFilterProps extends TextFieldProps {
  label: string;
  value?: string;
}
type TextFilterTriggerProps = {
  isOpen: boolean;
  label: string;
  value: string;
};
const TextFilter: FC<TextFilterProps> = ({ label, value, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [val, setVal] = useState(value ?? "");
  useEffect(() => {
    setVal(value ?? "");
  }, [value]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVal(e.target.value);
    props.onChange?.(e);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <TextFilterTrigger isOpen={isOpen} label={label} value={val} />
      <PopoverContent className="min-w-fit">
        <TextField {...props} value={val} onChange={handleChange} />
      </PopoverContent>
    </Popover>
  );
};

const TextFilterTrigger = ({
  isOpen,
  label,
  value,
}: TextFilterTriggerProps) => {
  return (
    <PopoverTrigger>
      <Button
        asChild
        variant="ghost"
        rightIcon={isOpen ? "chevron-up" : "chevron-down"}
        className={isOpen ? "bg-gray-100" : ""}
      >
        {label}
        <Typography className="text-gray-700 font-normal">{value}</Typography>
      </Button>
    </PopoverTrigger>
  );
};
export { TextFilter };
